import { render, staticRenderFns } from "./FollowupPopover.vue?vue&type=template&id=74028a12&scoped=true"
import script from "./FollowupPopover.vue?vue&type=script&lang=js"
export * from "./FollowupPopover.vue?vue&type=script&lang=js"
import style0 from "./FollowupPopover.vue?vue&type=style&index=0&id=74028a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74028a12",
  null
  
)

export default component.exports